<template>
    <normal-page name="Videos">
        <div class="grid content-center gap-4 sm:gap-6 sm:grid-cols-2">
            <template
                v-for="(video, i) in videos"
                :key="i"
            >
                <div class="panel mx-auto w-full max-w-[415px] p-2 transition-colors duration-300 hover:border-foam/15 sm:p-3">
                    <youtube-player
                        :id="`video-${video.id}`"
                        :video="video"
                        @click="pauseOtherVideos(video.id)"
                        @load-video="pauseOtherVideos(video.id)"
                    />
                </div>
            </template>
        </div>
    </normal-page>
</template>

<script>
    // Components
    import { defineComponent } from 'vue';
    import NormalPage from '@/components/layout/pages/NormalPage';
    import YoutubePlayer from '@/components/players/YoutubePlayer';
    // Library
    import store from '@/store/store';

    export default defineComponent({
        name: 'VideosView',

        components: {
            NormalPage,
            YoutubePlayer,
        },

        setup() {
            const { videos } = store.getters;

            const pauseOtherVideos = (currentVideoId) => {
                videos.forEach((video) => {
                    if (video.id !== currentVideoId) {
                        const videoFrame = document
                            .getElementById(`video-${video.id}`)
                            ?.getElementsByTagName('iframe')[0];

                        videoFrame?.contentWindow
                            .postMessage(
                                '{"event":"command","func":"pauseVideo","args":""}',
                                '*',
                            );
                    }
                });
            };

            return {
                videos,
                pauseOtherVideos,
            };
        },
    });
</script>
